import { configurationElement, formField, typeDatabase, typeFormValue } from "./configurationPropertyUtils";
import { ElementParse } from "../ParseClass/Element.Parse";
import { ElementTypeParse } from "../ParseClass/ElementType.Parse";

export const dataTypePossibleCommands = ['BOOL', 'NUMBER']


export const configurationPropertyElementParse: configurationElement[] =
    [
        {
            keyName: 'createdAt',
            varianteKey: '',
            traductionKey: 'createdAt',
            typeForm: typeFormValue.DATE,
            typeDatabase: typeDatabase.DATE,
            editable: false,
            showInForm: false,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            pointer: undefined,
            sortingValue: 200,
            section: 0,
            forms: undefined
        },
        {
            keyName: 'updatedAt',
            varianteKey: '',
            traductionKey: 'updatedAt',
            typeForm: typeFormValue.DATE,
            typeDatabase: typeDatabase.DATE,
            editable: false,
            showInForm: false,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            pointer: undefined,
            sortingValue: 300,
            section: 0,
            forms: undefined
        },

        {
            keyName: 'notes',
            varianteKey: undefined,
            traductionKey: 'elementParse.notes',
            typeForm: typeFormValue.INPUT_TEXT,
            typeDatabase: typeDatabase.STRING,
            editable: true,
            batchEdit: true,
            showInForm: true,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            pointer: undefined,
            sortingValue: 600,
            section: 0,
            forms: undefined
        }, {
            keyName: 'floor',
            varianteKey: undefined,
            traductionKey: 'elementParse.floor',
            typeForm: typeFormValue.ELENCO_APERTO,
            typeDatabase: typeDatabase.NUMBER,
            possibleValueIsInVariableComponent: true,
            editable: true,
            batchEdit: true,
            showInForm: true,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            pointer: undefined,
            sortingValue: 600,
            section: 0,
            forms: undefined
        }, {
            keyName: 'environment',
            varianteKey: undefined,
            traductionKey: 'elementParse.environment',
            typeForm: typeFormValue.ELENCO_APERTO,
            typeDatabase: typeDatabase.STRING,
            editable: true,
            batchEdit: true,
            showInForm: true,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            possibleValueIsInVariableComponent: true,
            pointer: undefined,
            sortingValue: 600,
            section: 0,
            forms: undefined
        }, {
            keyName: 'room',
            varianteKey: undefined,
            traductionKey: 'elementParse.room',
            typeForm: typeFormValue.ELENCO_APERTO,
            typeDatabase: typeDatabase.STRING,
            editable: true,
            batchEdit: true,
            showInForm: true,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            possibleValueIsInVariableComponent: true,
            pointer: undefined,
            sortingValue: 600,
            section: 0,
            forms: undefined
        },
        {
            keyName: 'name',
            varianteKey: undefined,
            traductionKey: 'elementParse.name',
            typeForm: typeFormValue.INPUT_TEXT,
            typeDatabase: typeDatabase.STRING,
            editable: true,
            batchEdit: false,
            showInForm: true,
            filtrable: true,
            copyable: false,
            required: true,
            possibleValues: undefined,
            pointer: undefined,
            sortingValue: 500,
            section: 0,
            forms: undefined
        },
        {
            keyName: 'prycam_id',
            varianteKey: undefined,
            traductionKey: 'elementParse.prycam_id',
            typeForm: typeFormValue.INPUT_TEXT,
            typeDatabase: typeDatabase.STRING,
            editable: true,
            batchEdit: true,
            showInForm: false,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            pointer: undefined,
            sortingValue: 550,
            section: 0,
            forms: undefined
        }, {
            keyName: 'SAP_id',
            varianteKey: undefined,
            traductionKey: 'elementParse.SAP_id',
            typeForm: typeFormValue.INPUT_TEXT,
            typeDatabase: typeDatabase.STRING,
            editable: true,
            batchEdit: true,
            showInForm: false,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            pointer: undefined,
            sortingValue: 550,
            section: 0,
            forms: undefined
        },
        {
            keyName: 'parentElement',
            varianteKey: undefined,
            traductionKey: 'elementParse.parentElement',
            typeForm: typeFormValue.ELENCO_APERTO,
            typeDatabase: typeDatabase.POINTER,
            editable: true,
            batchEdit: true,
            showInForm: true,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            sortingValue: 600,
            section: 0,
            forms: undefined,
            pointer: {
                className: 'Element',
                getValue: (element: ElementParse) => {
                    return element.name
                },
                getValueToSave: (element: ElementParse) => {
                    return { objectId: element.objectId }
                }
            },
        },
        {
            keyName: 'type',
            varianteKey: undefined,
            traductionKey: 'elementParse.type',
            typeForm: typeFormValue.ELENCO_APERTO,
            typeDatabase: typeDatabase.POINTER,
            editable: true,
            batchEdit: true,
            showInForm: true,
            filtrable: true,
            copyable: false,
            required: true,
            possibleValues: undefined,
            sortingValue: 700,
            section: 0,
            forms: undefined,
            pointer: {
                className: 'ElementType',
                getValue: (element: ElementTypeParse) => {
                    return element.name
                },
                getValueToSave: (element: ElementParse) => {
                    return { objectId: element.objectId }
                }
            },
        },
        {
            keyName: 'tags',
            varianteKey: undefined,
            traductionKey: 'elementParse.tags',
            typeForm: typeFormValue.INPUT_ARRAY_CHIPS,
            typeDatabase: typeDatabase.ARRAY,
            editable: true,
            batchEdit: true,
            showInForm: true,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            sortingValue: 750,
            section: 0,
            forms: undefined,
            pointer: undefined
        },
        {
            keyName: 'calculateCounter',
            varianteKey: undefined,
            traductionKey: 'elementParse.calculateCounter',
            typeForm: typeFormValue.CHECKBOX,
            typeDatabase: typeDatabase.BOOLEAN,
            editable: true,
            batchEdit: true,
            showInForm: true,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            sortingValue: 800,
            section: 0,
            forms: undefined,
            pointer: undefined
        }, 
        {
            keyName: 'calculateWorkingHoursCounter',
            varianteKey: undefined,
            traductionKey: 'elementParse.calculateWorkingHoursCounter',
            typeForm: typeFormValue.CHECKBOX,
            typeDatabase: typeDatabase.BOOLEAN,
            editable: true,
            batchEdit: true,
            showInForm: true,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            sortingValue: 850,
            section: 0,
            forms: undefined,
            pointer: undefined
        }, 
        {
            keyName: 'hidden',
            varianteKey: undefined,
            traductionKey: 'elementParse.hidden',
            typeForm: typeFormValue.CHECKBOX,
            typeDatabase: typeDatabase.BOOLEAN,
            editable: true,
            batchEdit: true,
            showInForm: true,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            sortingValue: 900,
            section: 0,
            forms: undefined,
            pointer: undefined
        }, {
            keyName: 'location',
            varianteKey: undefined,
            traductionKey: 'IotDevices.location',
            typeForm: typeFormValue.GEO_POINT,
            typeDatabase: typeDatabase.GEOPOINT,
            editable: true,
            batchEdit: false,
            showInForm: true,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            sortingValue: 1000,
            section: 0,
            forms: undefined,
            pointer: undefined
        },
        {
            keyName: 'photo',
            varianteKey: undefined,
            traductionKey: 'elementParse.photo',
            typeForm: typeFormValue.IMAGE,
            typeDatabase: typeDatabase.FILE,
            editable: true,
            batchEdit: false,
            showInForm: true,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            sortingValue: 1100,
            section: 0,
            forms: undefined,
            pointer: undefined,
        },

    ];
//     {
//     keyName: 'tipologia',
//     varianteKey: undefined,
//     traductionKey: 'tipologia',
//     typeForm: typeFormValue.ELENCO_APERTO,
//     typeDatabase: typeDatabase.STRING,
//     editable: true,
//     showInForm: true,
//     filtrable: true,
//     copyable: true,
//     required: false,
//     possibleValues: [
//         "attraversamentoPedonale"
//         , "bikeSharing"
//         , "cassonetto"
//         , "cestino"
//         , "colonnineRicaricaElettrica"
//         , "dissuasore"
//         , "dosso"
//         , "fermataBus"
//         , "fermataTaxi"
//         , "fermataTram"
//         , "fontana"
//         , "fotoZona"
//         , "panchina"
//         , "parcoGiochi"
//         , "parcometro"
//         , "rastrelliera"
//         , "segnaleStradale"
//         , "semaforo"
//         , "telecamera"
//         , "tombino"
//     ],
//     pointer: undefined,
//     sortingValue: 600,
//     section: 0,
//     forms: {
//         databaseKey: 'detail',
//         values: {
//             attraversamentoPedonale: typeArredoUrbanoValueForm.attraversamentoPedonale_colonnineRicaricaElettrica,
//             colonnineRicaricaElettrica: typeArredoUrbanoValueForm.attraversamentoPedonale_colonnineRicaricaElettrica
//         }
//     }
// }